import { render, staticRenderFns } from "./question-detail.component.html?vue&type=template&id=286d594e&scoped=true&external"
import script from "./question-detail.component.ts?vue&type=script&lang=ts&external"
export * from "./question-detail.component.ts?vue&type=script&lang=ts&external"
import style0 from "./question-detail.component.scss?vue&type=style&index=0&id=286d594e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286d594e",
  null
  
)

export default component.exports